var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "loginInner"
    }
  }, [_vm.selectedCard === _vm.LoginCardEnum.LOGIN ? _c('LoginEnterPassword', {
    attrs: {
      "initialMailValue": _vm.mail,
      "initialPasswordValue": _vm.password,
      "changeMail": _vm.changeMail,
      "changePassword": _vm.changePassword,
      "changeCard": _vm.changePasswordCard,
      "onLogin": _vm.onLogin,
      "isBackToLoginResetVisible": _vm.isBackToLoginResetVisible
    }
  }) : _vm._e(), _vm.selectedCard === _vm.LoginCardEnum.FORGOT ? _c('LoginForgotPassword', {
    attrs: {
      "initialMailValue": _vm.mail,
      "hidePasswordCard": _vm.showLoginCard,
      "changeCard": _vm.changePasswordCard,
      "changeMail": _vm.changeMail
    }
  }) : _vm._e(), _vm.selectedCard === _vm.LoginCardEnum.RESET ? _c('LoginReset', {
    attrs: {
      "initialMailValue": _vm.mail,
      "initialCode": _vm.code,
      "changeMail": _vm.changeMail,
      "changePassword": _vm.changePassword,
      "changeCard": _vm.showLoginCard,
      "showBackToLoginReset": _vm.showBackToLoginReset
    }
  }) : _vm._e(), _vm.selectedCard === _vm.LoginCardEnum.SET ? _c('LoginSet', {
    attrs: {
      "initialMailValue": _vm.mail,
      "changeCard": _vm.showLoginCard,
      "changeMail": _vm.changeMail,
      "changePassword": _vm.changePassword,
      "onLogin": _vm.onLogin,
      "initialPasswordValue": _vm.previousPassword
    }
  }) : _vm._e(), _vm.selectedCard === _vm.LoginCardEnum.LOGOUT ? _c('Logout') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }